import React from 'react';

import { MainMenuModal } from 'components/complex/modals/MainMenuModal';
import DesktopMenu from 'components/pagesComponents/landing/Main/components/DesktopMenu';
import MobileMenu from 'components/pagesComponents/landing/Main/components/MobileMenu';

export default function Menu({
  hideTopBanner,
}: {
  hideTopBanner?: boolean;
}): JSX.Element {
  return (
    <div>
      <MobileMenu hideTopBanner={hideTopBanner} />
      <DesktopMenu hideTopBanner={hideTopBanner} />
      <MainMenuModal />
    </div>
  );
}
